<span></span>
<ion-app
  dir="{{ textDir }}"
>
  <ion-split-pane contentId="menu-content" when="lg" disabled="false">
    <ion-menu contentId="menu-content" class="app-sidemenu" swipe-gesture="false">
      <ion-header class="ion-padding-top">
          <div class="ion-margin-bottom">
            <img src="/assets/images/logo-sidemenu.jpg" />
          </div>
          <ion-item color="common-darkest" button lines="none" routerLink="./settings">
            @if(bar()?.photoURL) {
              <app-aspect-ratio [ratio]="{ w: 1, h: 1 }" slot="start">
                <ion-avatar>
                  <img src="{{ bar()?.photoURL }}" />
                </ion-avatar>
              </app-aspect-ratio>
            }
            <ion-label>
              @if(bar()?.name) {
                <div>
                  <strong data-testid="sidemenu-bar-name">{{ bar()?.name }}</strong>
                </div>
              }
              <ion-note>{{ user()?.email }}</ion-note>
              <div>
                @if(hasPremium() === true) {
                  <ion-note color="medium">
                    Premium
                  </ion-note>
                }
                @if(hasPremium() == false) {
                  <ion-note color="medium">
                    Free
                  </ion-note>
                }
              </div>
            </ion-label>
          </ion-item>
      </ion-header>
      <ion-content>
        <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
          <ion-refresher-content></ion-refresher-content>
        </ion-refresher>

        <ion-list class="ion-no-padding">
          @for(p of appPages; track p.id; let i = $index) {
            <ion-menu-toggle auto-hide="false">
              <ion-item
                (click)="gotTo(hasPremium(), p, i)"
                button
                lines="none"
                detail="false"
                [class.selected]="selectedIndex == i"
              >
                @if(p.src) {
                  <ion-icon slot="start" [src]="p.src"></ion-icon>
                }
                @if(!p.src) {
                  <ion-icon
                    slot="start"
                    [name]="p.icon + '-outline'"
                  ></ion-icon>
                }
                <ion-label>
                  {{ p.title }}
                  @if(p.badge) {
                    <ion-badge color="success">{{ p.badge }}</ion-badge>
                  }
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
          <ion-item button (click)="signOut()" class="ion-hide-md-down">
            <ion-icon name="log-out" slot="start"></ion-icon>
            <ion-label>Sign out</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="menu-content">
      <ion-tabs>
        <ion-tab-bar slot="bottom" class="ion-display-lg-none">
          <ion-tab-button tab="home">
            <ion-icon name="home"></ion-icon>
            <ion-label>Home</ion-label>
          </ion-tab-button>

          <ion-tab-button tab="inventory">
            <ion-icon name="beer"></ion-icon>
            <ion-label>Inventory</ion-label>
          </ion-tab-button>

          <ion-tab-button tab="tv">
            <ion-icon name="tv"></ion-icon>
            <ion-label>OnTap TV</ion-label>
          </ion-tab-button>

          <ion-tab-button tab="settings">
            @if(bar()?.photoURL){
              <ion-avatar>
                <img src="{{ bar()?.photoURL }}" />
              </ion-avatar>
            } @else {
              <ion-icon name="person-circle-outline"></ion-icon>
            }
            <ion-label>Profile</ion-label>
            @if(supportUnreadCount() > 0){
              <ion-badge color="success">
                {{ supportUnreadCount() }}
              </ion-badge>
            }
          </ion-tab-button>
        </ion-tab-bar>
      </ion-tabs>
    </ion-router-outlet>

  </ion-split-pane>

</ion-app>

<app-cheers-toast></app-cheers-toast>
